import React, { useEffect, useState } from "react";
import { Control, UseFormRegister } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
type Inputs = any;

type text = { text: string };

interface Props {
  register: UseFormRegister<Inputs>;
  errors: any;
  name: string;
  options: text[];
  label: string;
  translateId?: string;
  disabled?: boolean;
  printEnabled?: boolean;
  control?: Control<any>;
}

const CustomCheckboxes: React.FC<Props> = ({
  register,
  errors,
  name,
  options,
  label,
  translateId,
  disabled,
  printEnabled = false,
  control,
}) => {
  const { t } = useTranslation();
  const [checkedCheckboxes, setCheckedCheckboxes] = useState<string[]>([]);

  useEffect(() => {
    if (control?._defaultValues[name]) {
      setCheckedCheckboxes(control?._defaultValues[name]);
    }
  }, [control?._defaultValues, name]);

  const handleCheckboxChange = (value: string, checked: boolean) => {
    const newValues = checked
      ? [...checkedCheckboxes, value]
      : checkedCheckboxes.filter((v: string) => v !== value);
    setCheckedCheckboxes(newValues);
  };

  return (
    <div className="relative my-5 grid md:grid-cols-2 grid-cols-1 w-full gap-[10px] md:gap-0">
      <div className="font-normal text-xl text-[#1E408E]">
        <Trans t={t}>{label}</Trans>
      </div>
      <div className="flex flex-row justify-between gap-x-4">
        <div className="grid gap-3 lg:px-5">
          {options.map((item, index) => (
            <label
              key={options.indexOf(item)}
              className="flex items-start gap-5"
              htmlFor={`${name}-${index}`}
            >
              <input
                className="multi-select"
                type="checkbox"
                {...register(`${name}`)}
                id={`${name}-${index}`}
                value={`${item.text}`}
                disabled={disabled}
                onChange={(selected) => handleCheckboxChange(item.text, selected.target.checked)}
                checked={checkedCheckboxes?.includes(item.text)}
              />

              <span className="font-normal text-base leading-tight">
                <Trans t={t}>{item.text}</Trans>
              </span>
            </label>
          ))}
        </div>
        {printEnabled && (
          <div className="pr-10">
            <input type="checkbox" {...register(`print${name}`)} defaultChecked id={`${name}`} />
          </div>
        )}
      </div>
      <p className="text-red-500 text-xs">{errors[name]?.message}</p>
      <style>{`
      .multi-select:disabled:checked{
        background-color:gray;
        border-color:gray;
      }
      `}</style>
    </div>
  );
};

export default CustomCheckboxes;
